import React from 'react';

import { iframe } from './rating.module.scss';

const RatingFromServey = ({ title, src }) => {
  return (
    <iframe
      src={src}
      width="100%"
      height="420px"
      title={title}
      className={iframe}
    ></iframe>
  );
};

export default RatingFromServey;
